import { render } from "./ContactVue.vue?vue&type=template&id=0b354239&scoped=true"
import script from "./ContactVue.vue?vue&type=script&lang=js"
export * from "./ContactVue.vue?vue&type=script&lang=js"

import "./ContactVue.vue?vue&type=style&index=0&id=0b354239&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b354239"]])

export default __exports__